export const TERMINOS_PDF_FILENAME = 'TyC_Flux_V30.2.pdf';
export const TERMINOS_PDF_PATH = `/${TERMINOS_PDF_FILENAME}`;
